import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const RecursionPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Recursion </h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title="Factorial"
          description="Calculates a number by multiplying it with all smaller positive integers."
          link="/recursion/factorial"
          icon="🧮"
        />
        <TopicCard
          title="Fibonacci Sequence"
          description="Generates numbers where each is the sum of the two before it."
          link="/recursion/fibonacci"
          icon="🔢"
        />
        <TopicCard
          title="Palindrome Check"
          description="Determines if a word or number reads the same forward and backward."
          link="/recursion/palindrome"
          icon="🔁"
        />
          <TopicCard
          title="Compare Recursion"
          description="Visualize how different recursive patterns unfold and resolve."
          link="/recursion/comparerecursion"
          icon="⚖️"
        />
      </div>
    </div>
  );
};

export default RecursionPage;